<template>
  <div class="templates-wrapper" ref="productWrapper">
    <Content0
      id="Content0_0"
      :is-mobile="isMobile"
    />
  </div>
</template>

<script>
import Content0 from './Content0.vue'

export default {
  name: 'ProductView',
  components: {
    Content0
  },
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    // 适配手机屏幕
    this.enquireScreen(b => {
      this.isMobile = !!b
    })
  },
  methods: {
    enquireScreen(cb) {
      const mediaQuery = window.matchMedia('(max-width: 768px)')
      cb(mediaQuery.matches)
      mediaQuery.addListener(mq => cb(mq.matches))
    }
  }
}
</script>

<style scoped>
.templates-wrapper {
  width: 100%;
  min-height: 100vh;
}
</style>